// EN-версия живёт на поддомене en.episnya.live (и на ?en=1 для локальной проверки).
export const isEnglishSite = () => {
  if (typeof window === "undefined") return false;
  try {
    if (new URLSearchParams(window.location.search).get("en") === "1") return true;
    return /^en\./i.test(window.location.hostname);
  } catch {
    return false;
  }
};

export const siteLocale = () => (isEnglishSite() ? "en" : "ua");
